module.exports = __webpack_public_path__ + "static/media/trustWallet.a4d67bb9.svg";